'use es6';

import { Record } from 'immutable';
const DEFAULTS = {
  duration: null,
  text: '',
  value: ''
};
export default class Video extends Record(DEFAULTS) {
  static fromJS({
    model,
    label
  }) {
    const videoId = model.meta && model.meta.original_external_uuid ? model.meta.original_external_uuid : model.external_uuid || model.crm_object_id;
    return new Video({
      duration: model.duration,
      text: label,
      value: videoId
    });
  }
}